import {isPlatformBrowser} from '@angular/common';
import {inject, Injectable, InjectionToken, PLATFORM_ID} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class HostnameService {
  private hostname = inject(APP_HOSTNAME);
  private platformId = inject<Object>(PLATFORM_ID);


  getHostname(): string {
    if (this.hostname) {
      return this.hostname;
    }

    if (isPlatformBrowser(this.platformId)) {
      return window.location.origin;
    }

    // Return a fallback for server-side rendering
    return '';
  }
}

export const APP_HOSTNAME = new InjectionToken<string>('APP_HOSTNAME', {providedIn: 'platform', factory: () => ''});
